import { render, staticRenderFns } from "./linkPage.vue?vue&type=template&id=040c99c5&"
import script from "./linkPage.vue?vue&type=script&lang=js&"
export * from "./linkPage.vue?vue&type=script&lang=js&"
import style0 from "./linkPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports